import { render, staticRenderFns } from "./PoliticasDePrivacidade.vue?vue&type=template&id=632b8897"
import script from "./PoliticasDePrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticasDePrivacidade.vue?vue&type=script&lang=js"
import style0 from "./PoliticasDePrivacidade.vue?vue&type=style&index=0&id=632b8897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports